import {getBlockingAsyncActionTypes, getSilentAsyncActionTypes} from './util';

export const CONFIG_EDITOR__ACTIONSCOPE = 'CONFIG_EDITOR_ACTION_SCOPE';

export const INITIALIZE_ASSETS__ACTIONTYPE = 'INITIALIZE_ASSETS';
export const ADD_ASSETS__ACTIONTYPE = 'ADD_ASSETS';
export const REMOVE_ASSETS__ACTIONTYPE = 'REMOVE_ASSETS';
export const SWITCH_TO_ASSET__ACTIONTYPE = 'SWITCH_TO_ASSET';
export const CHANGE_ASSET__ACTIONTYPE = 'CHANGE_ASSET';
export const SAVE_ASSET__ACTIONTYPE = 'SAVE_ASSET';
export const REVERT_ASSET__ACTIONTYPE = 'REVERT_ASSET';
export const LOAD_ASSETS__ACTIONTYPES = getBlockingAsyncActionTypes('LOAD_ASSETS');
export const RESET_ASSETS__ACTIONTYPE = 'RESET_ASSETS';
export const CLEAR_LOAD_RESULT__ACTIONTYPE = 'CLEAR_LOAD_RESULT';
export const EXPORT_ASSETS__ACTIONTYPES = getBlockingAsyncActionTypes('EXPORT_ASSETS');
export const IMPORT_ASSETS__ACTIONTYPES = getBlockingAsyncActionTypes('IMPORT_ASSETS');
export const VALIDATE_ASSETS__ACTIONTYPES = getSilentAsyncActionTypes('VALIDATE_ASSETS');
export const SET_RATER_TYPE__ACTIONTYPE = 'SET_RATER_TYPE';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/constants/config-editor.ts